import React, { useState } from "react";
import Dropzone, { useDropzone } from "react-dropzone";
import { ImCross } from "react-icons/im";
import { Button } from "../../../Component/Button/Button";
import { empty_video_thumbnail } from "../../../constant/imagePath";
// import { word_file_icon } from "../../../constant/imagePath";
import classes from "./Step1.module.css";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const Step1 = ({
  setText,
  text = "asdsadas ",
  isFile,
  setIsFile,
  setVideFile,
}) => {
  const [clicked, setClicked] = useState(true);
  const validateFileType = (file) => {
    const acceptedTypes = [
      "video/mp4",
      ".mkv",
      ".avi", // .video file extention list
    ];
    const fileType = file.type;

    if (acceptedTypes.includes(fileType)) {
      return false;
    } else {
      return toast.warn("Please Add Video");
    }
  };
  return (
    <>
      {!isFile ? (
        <>
          <Dropzone
            validator={validateFileType}
            //   accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            //   accept=".docx"
            //   accept={{ "application/msword": [] }}
            // noClick={true}
            //   disabled={true}
            onDrop={(acceptedFiles) => {
              // if we have file
              if (acceptedFiles.length > 0) {
                const url = URL.createObjectURL(acceptedFiles[0]);
                const video = document.createElement("video");
                video.src = url;
                video.addEventListener("loadedmetadata", function () {
                  console.log(this.videoWidth, this.videoHeight);

                  if (!isResolutionAllowed(this.videoWidth, this.videoHeight)) {
                    toast.info(
                      <>
                        <p>
                          <b>Resolution should be one of the following</b>
                        </p>
                        <ul className="p-0">
                          {allowedResolutions.map((item, index) => {
                            return (
                              <li key={index}>
                                {item.width}x{item.height}
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    );
                    return;
                  }

                  setIsFile(URL.createObjectURL(acceptedFiles[0]));
                  setVideFile(acceptedFiles[0]);
                });
              }
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <section className={classes.uploadBox}>
                <div
                  className={classes.input_box}
                  style={{
                    display: isFile && "flex",
                    alignItems: isFile && "center",
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  {isFile?.length > 0 ? (
                    <div className={classes.div_main}>
                      <div
                        className={classes.cross_icon}
                        onClick={() => setIsFile([])}
                      >
                        <ImCross />
                      </div>
                      {/* <img src={word_file_icon} /> */}
                    </div>
                  ) : (
                    <div className={classes.empty_video_div}>
                      <div className={classes.img_div_thumbail}>
                        <img src={empty_video_thumbnail} />
                      </div>
                      <h4>Drag & Drop</h4>
                      <h4>
                        Or <span>Browse</span>
                      </h4>
                    </div>
                  )}
                </div>
              </section>
            )}
          </Dropzone>
        </>
      ) : (
        <>
          <div className={classes.video_tag}>
            {/* {isFile && (
              <ReactPlayer
              
                // width={300}
                // height={300}
                url={isFile}
                style={{
                  width: "178px !important",
                  height: "160px !important",
                }}
              />
            )} */}
            <video autoplay src={isFile} controls></video>
          </div>
        </>
      )}
    </>
  );
};

export default Step1;

const allowedResolutions = [
  {
    width: 1080,
    height: 1920,
  },
  {
    width: 720,
    height: 1280,
  },
  {
    width: 480,
    height: 854,
  },
  {
    width: 576,
    height: 1024,
  },
];

function isResolutionAllowed(width, height) {
  return allowedResolutions.some((resolution) => {
    return resolution.width === width && resolution.height === height;
  });
}
